module.exports = __webpack_public_path__ + "img/account.4a60ce23.svg";